/**
 * BriefingModal — the Media Centre audio briefing modal.
 */
import React from 'react';
import WolfoxWidget from '../../Wolfox/WolfoxWidget';

function BriefingModal({ briefing, onClose }) {
    const title = briefing.topic || briefing.title;

    return (
        <div className="image-modal-overlay" onClick={onClose}>
            <div className="image-modal-container briefing-modal-container" onClick={(e) => e.stopPropagation()}>
                <div className="image-modal-header">
                    <h3>
                        <span>{title && title.length > 50 ? `${title.substring(0, 50)}...` : title}</span>
                    </h3>
                    <button className="image-modal-close" onClick={onClose} title="Close briefing">
                        <i className="fas fa-times"></i>
                    </button>
                </div>
                <div className="image-modal-content briefing-modal-content">
                    <WolfoxWidget type="daily-policy" briefing={briefing.briefingCode} />
                </div>
                <div className="image-modal-info">
                    <div className="image-modal-meta media-meta">
                        <span>
                            <i className="fas fa-calendar"></i>{' '}
                            {new Date(briefing.publishDate).toLocaleDateString('en-GB', {
                                day: 'numeric',
                                month: 'short',
                                year: 'numeric',
                            })}
                        </span>
                        <span className="entity"><i className="fas fa-building"></i> {briefing.entity}</span>
                    </div>
                    {briefing.shortDescription && (
                        <div className="image-description">
                            <p>{briefing.shortDescription}</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default BriefingModal;
